"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/SecureText/ClickExplainer.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _Tooltip = require('web/components/Tooltip');
var _common = require('web/components/Tooltip/common');
var _SecureTextExplainer = require('./SecureTextExplainer'); var _SecureTextExplainer2 = _interopRequireDefault(_SecureTextExplainer);











// Opens the secure vs. insecure explainer only when you ask for it: a click on
// the trigger, or Enter / Space while it has focus. Never on hover or focus,
// so it can't pop up by itself as a chat opens or the pointer passes over.
// A click elsewhere, Escape, or tabbing away closes it.
const ClickExplainer = ({ variant, className, label, title, children }) => {
  const [isOpen, setIsOpen] = _react.useState.call(void 0, false)
  const [position, setPosition] = _react.useState(null)
  const wrapperRef = _react.useRef(null)
  const triggerRef = _react.useRef(null)
  const popoverRef = _react.useRef(null)

  const close = _react.useCallback.call(void 0, () => {
    setIsOpen(false)
    setPosition(null)
  }, [])
  const toggle = _react.useCallback.call(void 0, () => {
    if (isOpen) close()
    else setIsOpen(true)
  }, [isOpen, close])

  // Measure once the popover is in the DOM, then place it under the trigger.
  _react.useLayoutEffect.call(void 0, () => {
    if (!isOpen || position) return
    setPosition(_common.getTooltipPosition.call(void 0, triggerRef.current, popoverRef.current, 'bottom-left', true))
  }, [isOpen, position])

  _react.useEffect.call(void 0, () => {
    if (!isOpen) return
    const onPointerDown = (e) => {
      if (!_optionalChain([wrapperRef, 'access', _ => _.current, 'optionalAccess', _2 => _2.contains, 'call', _3 => _3(e.target )])) close()
    }
    document.addEventListener('mousedown', onPointerDown)
    return () => document.removeEventListener('mousedown', onPointerDown)
  }, [isOpen, close])

  // The trigger sits inside clickable things (an inbox row): it acts alone.
  const onTriggerClick = (e) => {
    e.stopPropagation()
    toggle()
  }

  const onTriggerKeyDown = (e) => {
    if (e.key !== 'Enter' && e.key !== ' ') return
    e.preventDefault()
    e.stopPropagation()
    toggle()
  }

  const onKeyDown = (e) => {
    if (e.key === 'Escape' && isOpen) close()
  }

  const onBlur = (e) => {
    if (isOpen && !e.currentTarget.contains(e.relatedTarget )) close()
  }

  return (
    _react2.default.createElement('span', {
      ref: wrapperRef,
      className: _classBuilder2.default.call(void 0, "secure-text--hover", className),
      onKeyDown: onKeyDown,
      onBlur: onBlur, __self: this, __source: {fileName: _jsxFileName, lineNumber: 75}}

      , _react2.default.createElement('span', {
        ref: triggerRef,
        className: "secure-text--hover-trigger",
        role: "button",
        tabIndex: 0,
        'aria-label': label,
        'aria-haspopup': "dialog",
        'aria-expanded': isOpen,
        title: title,
        onClick: onTriggerClick,
        onKeyDown: onTriggerKeyDown, __self: this, __source: {fileName: _jsxFileName, lineNumber: 81}}

        ,  children 
      )
      ,  isOpen && (
        _react2.default.createElement('div', {
          ref: popoverRef,
          className: "blm-tooltip blm-tooltip--light secure-text--hover-popover"  ,
          style: _nullishCoalesce(position, () => ( { visibility: 'hidden' })),
          // Clicks inside (the help link, say) stay here: they mustn't open
          // the inbox row or close a dialog underneath.
          onClick: stopPropagation, __self: this, __source: {fileName: _jsxFileName, lineNumber: 96}}

          , _react2.default.createElement(_Tooltip.TooltipContent, { className: "secure-text--explainer-content", __self: this, __source: {fileName: _jsxFileName, lineNumber: 104}}
            , _react2.default.createElement(_SecureTextExplainer2.default, { variant: variant, __self: this, __source: {fileName: _jsxFileName, lineNumber: 105}} )
          )
        )
      )
    )
  )
}

const stopPropagation = (e) => e.stopPropagation()

exports. default = ClickExplainer
